import { Remarkable } from 'remarkable'
import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'

const iframeRegex = /(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))/g
const tableRegex = /<table[\s\S]*?>[\s\S]*?<\/table>/gi

const imgRegex = /<img .*?>/g
const srcAttributeRegex = /src="([^"]*)"/i

const remarkable = new Remarkable({
    linkTarget: '_blank',
    breaks: true,
})
const defaultOptions = {
    linkTarget: '',
    html: false,
}

export function renderMarkdown(markdown: any, args: any = {}) {
    const options = {
        ...defaultOptions,
        ...args,
    }
    remarkable.set(options)

    let result = remarkable.render(markdown)

    if (options.html) {
        // wrap iframes in element if html rendering is allowed
        result = result.replace(iframeRegex, function (iframeHtml) {
            let srcAttribute = (iframeHtml.match(srcAttributeRegex) || [])[0] || ''
            srcAttribute =
                srcAttribute && srcAttribute.length > 6 ? srcAttribute.substr(5, srcAttribute.length - 6) : ''
            return `<div class="iframe-wrapper" data-src="${srcAttribute}">${iframeHtml}</div>`
        })

        // wrap tables in element if html rendering is allowed
        result = result.replace(tableRegex, tableHtml => `<div class="table-wrapper">${tableHtml}</div>`)

        // rewrite image into picture tag to allow responsive images
        result = result.replace(imgRegex, function (imgHtml) {
            let extraSources = ''
            let srcAttribute = (imgHtml.match(srcAttributeRegex) || [])[0] || ''
            srcAttribute =
                srcAttribute && srcAttribute.length > 6 ? srcAttribute.substr(5, srcAttribute.length - 6) : ''

            if (srcAttribute.indexOf('images.ctfassets.net')) {
                const srcWithoutQuerystring = srcAttribute.split('?')[0]
                imgHtml = imgHtml.replace(
                    srcAttribute,
                    `${srcWithoutQuerystring}?q=90&fm=jpg&fl=progressive&w=1200?q=90&fm=jpg&fl=progressive&w=1200`
                )
                extraSources += `<source srcset="${srcWithoutQuerystring}?q=90&fm=webp&w=1200" type="image/webp">`
            }

            return `<picture>${extraSources}${imgHtml}</picture>`
        })
    }

    return result
}

@Pipe({
    name: 'markdown',
})
export class MarkdownPipe implements PipeTransform {
    constructor(protected sanitizer: DomSanitizer) {}

    transform(markdown: any, args: any = {}): any {
        const result = renderMarkdown(markdown, args)
        return this.sanitizer.bypassSecurityTrustHtml(result)
    }
}
